import { Globe2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { languages, useLocale } from '../i18n/LocaleProvider';

export const LanguageSelector = () => {
  const { locale, setLocale, t } = useLocale();
  return <div className="language-selector" translate="no">
    <Select value={locale} onValueChange={setLocale}>
      <SelectTrigger className="language-trigger" data-testid="language-selector" aria-label={t('Choose language')}><Globe2 size={16} /><SelectValue>{languages.find(l => l.code === locale).short}</SelectValue></SelectTrigger>
      <SelectContent className="language-options" data-testid="language-options" data-lenis-prevent>{languages.map(language => <SelectItem key={language.code} value={language.code} lang={language.code} data-testid={`language-option-${language.code}`}>{language.label}</SelectItem>)}</SelectContent>
    </Select>
  </div>;
};